import { render, staticRenderFns } from "./POrderCheckDocument.vue?vue&type=template&id=3dcf57ce&scoped=true&"
import script from "./POrderCheckDocument.vue?vue&type=script&lang=js&"
export * from "./POrderCheckDocument.vue?vue&type=script&lang=js&"
import style0 from "./POrderCheckDocument.vue?vue&type=style&index=0&id=3dcf57ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcf57ce",
  null
  
)

export default component.exports